import type { TPAComponentProps } from '../../types';

export enum CounterBadgePriority {
  primary = 'primary',
  secondary = 'secondary',
}

export interface CounterBadgeProps extends TPAComponentProps {
  /** There are 2 different themes: `primary` and `secondary`. The default value is ‘primary’. */
  priority?: CounterBadgePriority;
  /** define value that counterBadge will present */
  value: number;
  /** A number between 1  to 99 that defines the maximum value that above that number the counterBadge will present `+${maximum}` */
  maximum?: number;
}

export interface CounterBadgeDefaultProps {
  priority: CounterBadgePriority;
  maximum: number;
}
